import NotFound from "../../assets/img/notFound.gif";
const NoData = ({ message }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "300px",
        padding: "10px 0",
      }}
    >
      <h4>{message}</h4>
      <img
        style={{ width: "300px", objectFit: "contain" }}
        src={NotFound}
        alt=""
      />
    </div>
  );
};
export default NoData;
